module.exports = __webpack_public_path__ + "static/media/StartScreen_elImage2_494004.2a9c9788.jpg";